<template>
  <div class="countdown" :style="ogStyle">
    <span class="countdown-text longTouch">
      <!-- The Remaining Period:&nbsp; -->
      {{ `${localesPackage?.['og_cum']?.[localesEnv]}: ` }}
      <span class="countdown-time">{{ `${total_day} days` }}</span>
    </span>
    <span class="countdown-text longTouch">
      <!-- ${minute_show} minutes(s) ${second_show} second(s) -->
      {{ `${localesPackage?.['og_deadline']?.[localesEnv]}: ` }}
      <span class="countdown-time">{{ `${day_show} d'  ${hour_show} h'  ${minute_show} m'` }}</span>
    </span>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, computed } from "vue";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  components: {},
  props: {
    begin_time: {
      type: Number,
      default: 0,
    },
    end_time: {
      type: Number,
      default: 0,
    },
    total_day: {
      type: Number,
      default: 0,
    },
    ogStyle: {
      type: Object,
      default: ()=>{}
    }
  },
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    begin_time: {
      handler(value) {
        if (!value) {
          return;
        }
        this.init(value,this.end_time)
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup(props, { emit }) {
    const { begin_time, end_time } = props;

    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');

    const day_show = ref("00");
    const hour_show = ref("00");
    const minute_show = ref("00");
    const second_show = ref("00");

    let timer = null;
    const beginDiff = ref(0);
    const endDiff = ref(0);
    const timeDiff = ref(0); //时间差
    const endTime = ref(0);
    const startTime = ref(0);

    onMounted(() => {
      
    });

    const init = (begin_time,end_time)=>{
      getArtDate(begin_time, end_time);
      timer = setInterval(countDown, 1000);
      // return () => {
      //   clearInterval(timer);
      //   timer = null;
      // };
    }

    /**
     * 获取时间差
     */
    const setDiff = () => {
      const currentTime = new Date().getTime();

      // 当前时间距离活动开始时间的差值
      beginDiff.value = Math.floor((startTime.value - currentTime) / 1000);
      //当前时间距离活动结束时间的差值
      endDiff.value = Math.floor((endTime.value - currentTime) / 1000);

      if (beginDiff.value > 0) {
        timeDiff.value = beginDiff.value;
      } else if (endDiff.value > 0) {
        timeDiff.value = endDiff.value;
      } else {
        timeDiff.value = 0;
      }
    };

    /**
     * 获取公募开始结束时间
     */
    const getArtDate = async (start, end) => {
      // const data = [
      //   {
      //     start_time: 1670317183,
      //     end_time: 1670466899,
      //   },
      // ];
      // const start = data[0]?.start_time;
      // const end = data[0]?.end_time;

      startTime.value = start * 1000;
      endTime.value = end * 1000;

      setDiff();

      countDown();

    };

    /**
     * 处理格式化
     * @param i
     * @returns
     */
    function addZero(i) {
      return i < 10 ? "0" + i : i;
    }

    /**
     * 处理倒计时
     */
    const countDown = function () {
      if (timeDiff.value <= 0) {
        if (beginDiff.value > 0) {
          //开始倒计时结束后更新成结束倒计时
          setDiff();
        } else {
          timer && clearTimeout(timer);
          timer = null;
          return;
        }
      }
      timeDiff.value = timeDiff.value - 1;
      let day = Math.floor(timeDiff.value / (24 * 60 * 60));
      let hour = Math.floor((timeDiff.value / (60 * 60)) % 24);
      let minute = Math.floor((timeDiff.value / 60) % 60);
      let second = Math.floor(timeDiff.value % 60);

      day_show.value = addZero(day);
      hour_show.value = addZero(hour);
      second_show.value = addZero(second);
      minute_show.value = addZero(minute);
    };

    return {
      day_show,
      hour_show,
      second_show,
      minute_show,
      init,
      localesEnv,
      localesPackage
    };
  },
};
</script>

<style lang="less" scoped>
//阻止长按操作
.longTouch {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.countdown {
  width: 237px;
  height: 54px;
  opacity: 1;
  position: absolute;
  top: 148px;
  right: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  font-family: "PingFang HK";
  // text-shadow: rgba(0, 209, 255, 0.83) 0px 0px 12px;
  background: url("~@/assets/images/YuliApp/weeklyTask/og_countdown_bg.svg")
  no-repeat top left;
  background-size: 100% 100%;
  &-text {
    margin-bottom: 2px; 
  }
  &-time {
    color: #FFE600;
    margin-top: 4px; 
  }
}
</style>
